// src/components/Footer.js

import React, { useState } from 'react'; // Added useState
import { Link, useNavigate, useLocation } from 'react-router-dom';

const phoneNumber = "919610900002"; // Your WhatsApp number

// --- Define specific messages for the menu ---
const seekerMsg = encodeURIComponent("Hi, I am a Job Seeker and would like to know about available opportunities.");
const employerMsg = encodeURIComponent("Hi, I am an Employer and looking to hire staff through Acadfinity.");

const seekerUrl = `https://wa.me/${phoneNumber}?text=${seekerMsg}`;
const employerUrl = `https://wa.me/${phoneNumber}?text=${employerMsg}`;

const Footer = () => {
    // --- HOOKS ---
    const navigate = useNavigate();
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false); // State for WhatsApp menu

    // --- MISSING FUNCTION ADDED HERE ---
    const handleScrollToSection = (targetId) => {
        // Agar Home page par nahi hain, to Home par bhejo with ID
        if (location.pathname !== '/') {
            navigate(`/#${targetId}`);
        } else {
            // Agar Home par hain, to smooth scroll karo
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    };

    // URL-encoded address for Google Maps link
    const googleMapsUrl = "https://maps.app.goo.gl/rFrgLpC5sfkE7bTK7?g_st=awb";

    return (
        <footer className="bg-slate-900 text-white pt-16 pb-8 px-6 md:px-8">
            <div className="max-w-7xl mx-auto">
                
                {/* --- TOP SECTION: LOGO & MAIN LINKS --- */}
                <div className="flex flex-col md:flex-row justify-between gap-12">
                    {/* Left Column: Brand Info */}
                    <div className="md:w-1/3 space-y-4">
                        <img src="/images/logo.png" alt="Acadfinity" className="h-8 brightness-0 invert" />
                        <p className="text-slate-400 text-sm leading-relaxed">
                            India’s First K-12 School Ecosystem Partner.
                        </p>
                        <a 
                            href="https://acadfinity.com" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 text-sm font-bold text-brand-orange uppercase tracking-wider mt-2 hover:underline"
                        >
                            Visit Our Website
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path></svg>
                        </a>
                    </div>

                    {/* Right Columns: Link Groups */}
                    <div className="flex gap-16">
                        <div>
                            <h4 className="text-brand-orange font-bold text-sm uppercase tracking-wider mb-4">Support</h4>
                            <ul className="space-y-3 text-slate-400 text-sm">
                                {/* Ab ye button kaam karega kyunki function upar define kar diya hai */}
                                <button onClick={() => handleScrollToSection('FAQ')} className="hover:text-white transition-colors cursor-pointer bg-transparent border-none p-0 text-left">
                                    FAQ
                                </button>
                            </ul>
                        </div>
                        <div>
                            <h4 className="text-brand-orange font-bold text-sm uppercase tracking-wider mb-4">Legal</h4>
                            <ul className="space-y-3 text-slate-400 text-sm">
                                <li><Link to="/TermsAndConditions" className="hover:text-white transition-colors">Terms & Conditions</Link></li>
                                <li><Link to="/PrivacyPolicy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* --- DIVIDER --- */}
                <div className="my-10 border-t border-white/10"></div>

                {/* --- MIDDLE SECTION: CONTACT DETAILS --- */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {/* Address */}
                    <div>
                        <h5 className="text-[10px] font-black text-brand-orange uppercase tracking-widest mb-2">Corporate Office</h5>
                        <a 
                            href={googleMapsUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-slate-400 text-sm font-medium leading-relaxed hover:text-white transition-colors"
                        >
                            Mrityunjay - 12, Paota ‘C’ 5th Road,<br/>Jodhpur, Rajasthan - 342001, India
                        </a>
                    </div>
                    {/* Emails & Phone */}
                    <div className="flex flex-wrap gap-x-12 gap-y-6">
                         <div>
                            <h5 className="text-[10px] font-black text-brand-orange uppercase tracking-widest mb-1">Hiring Support</h5>
                            <a href="mailto:eduhr@acadfinity.com" className="text-sm font-semibold text-white hover:underline">
                                eduhr@acadfinity.com
                            </a>
                        </div>
                        <div>
                            <h5 className="text-[10px] font-black text-brand-orange uppercase tracking-widest mb-1">Support</h5>
                            <a href="mailto:careers@acadfinity.com" className="text-sm font-semibold text-white hover:underline">
                                careers@acadfinity.com
                            </a>
                        </div>
                        
                        <div>
                            <h5 className="text-[10px] font-black text-brand-orange uppercase tracking-widest mb-1">Inquiries</h5>
                            <a href="tel:+919610900001" className="text-sm font-semibold text-white hover:underline">
                                +91 961090 0001
                            </a>
                        </div>
                    </div>
                </div>

                {/* --- DIVIDER --- */}
                <div className="mt-10 pt-6 border-t border-white/10"></div>
                
                {/* --- BOTTOM BAR: COPYRIGHT & SOCIALS --- */}
                <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-slate-500 text-xs font-semibold tracking-wider">&copy; 2026 Acadfinity. All Rights Reserved.</p>
                     
                     {/* Social Links */}
                     <div className="flex gap-3">
                        <a href="https://www.instagram.com/acadfinity.in/" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-brand-orange transition-all"><svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.343 3.608 1.318.975.975 1.256 2.242 1.318 3.608.058 1.266.069 1.645.069 4.84s-.012 3.574-.069 4.84c-.062 1.366-.343 2.633-1.318 3.608-.975.975-2.242 1.256-3.608 1.318-1.266.058-1.645.069-4.85.069s-3.584-.012-4.85-.069c-1.366-.062-2.633-.343-3.608-1.318-.975-.975-1.256-2.242-1.318-3.608C2.175 15.574 2.163 15.195 2.163 12s.012-3.574.069-4.84c.062-1.366.343 2.633 1.318-3.608.975-.975 2.242-1.256 3.608-1.318C8.416 2.175 8.796 2.163 12 2.163zm0-2.163C8.741 0 8.332.013 7.052.072 5.775.131 4.602.443 3.635 1.41 2.668 2.377 2.356 3.55 2.297 4.828 2.238 6.108 2.225 6.517 2.225 12c0 5.483.013 5.892.072 7.172.059 1.278.371 2.451 1.338 3.418.967.967 2.14 1.279 3.418 1.338 1.28.059 1.689.072 7.172.072s5.892-.013 7.172-.072c1.278-.059 2.451-.371 3.418-1.338.967.967 1.279-2.14 1.338-3.418.059-1.28.072-1.689.072-7.172s-.013-5.892-.072-7.172c-.059-1.278-.371-2.451-1.338-3.418C19.451.443 18.278.131 17 .072 15.72.013 15.311 0 12 0zm0 5.838A6.162 6.162 0 1 0 18.162 12 6.169 6.169 0 0 0 12 5.838zm0 10.162A4 4 0 1 1 16 12a4.005 4.005 0 0 1-4 4zm6.406-11.845a1.44 1.44 0 1 0 1.44 1.44 1.44 1.44 0 0 0-1.44-1.44z"/></svg></a>
                        <a href="https://www.facebook.com/people/Acadfinity/61579767337569/" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-brand-orange transition-all"><svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M22.675 0h-21.35C.597 0 0 .597 0 1.326v21.348C0 23.403.597 24 1.326 24h11.495v-9.294H9.691V11.01h3.13V8.309c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.312h3.587l-.467 3.696h-3.12V24h6.116C23.403 24 24 23.403 24 22.674V1.326C24 .597 23.403 0 22.675 0z"/></svg></a>
                        <a href="https://www.linkedin.com/company/acadfinity/?originalSubdomain=in" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-brand-orange transition-all"><svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.6 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.069-.926-2.069-2.065 0-1.138.925-2.064 2.069-2.064 1.14 0 2.064.926 2.064 2.064 0 1.139-.925 2.065-2.064 2.065zM6.863 20.452H3.812V9h3.051v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.727v20.545C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.273V1.727C24 .774 23.2 0 22.225 0z"/></svg></a>
                    </div>
                </div>
            </div>

            {/* ▼▼▼ FLOATING WHATSAPP BUTTON WITH MENU ▼▼▼ */}
            <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end">
                
                {/* --- MENU: Visible only when isOpen is true --- */}
                {isOpen && (
                    <div className="mb-4 w-60 bg-white rounded-2xl shadow-2xl border border-slate-100 overflow-hidden animate-in slide-in-from-bottom-5 fade-in duration-300 origin-bottom-right">
                        <div className="bg-slate-900 px-4 py-3 border-b border-slate-800">
                            <p className="text-white text-xs font-bold uppercase tracking-wider">How can we help?</p>
                        </div>
                        
                        <div className="p-2 space-y-1">
                            {/* Option 1: Job Seeker */}
                            <a 
                                href={seekerUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => setIsOpen(false)}
                                className="flex items-center gap-3 w-full p-3 hover:bg-emerald-50 rounded-xl transition-colors group"
                            >
                                <div className="w-8 h-8 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-600 group-hover:bg-emerald-500 group-hover:text-white transition-colors">
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
                                </div>
                                <div className="text-left">
                                    <span className="block text-sm font-bold text-slate-700">I am a Job Seeker</span>
                                    <span className="block text-[10px] text-slate-400">Looking for a job</span>
                                </div>
                            </a>

                            {/* Option 2: Employer */}
                            <a 
                                href={employerUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => setIsOpen(false)}
                                className="flex items-center gap-3 w-full p-3 hover:bg-orange-50 rounded-xl transition-colors group"
                            >
                                <div className="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center text-orange-600 group-hover:bg-orange-500 group-hover:text-white transition-colors">
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path></svg>
                                </div>
                                <div className="text-left">
                                    <span className="block text-sm font-bold text-slate-700">I am an Employer</span>
                                    <span className="block text-[10px] text-slate-400">Looking to hire</span>
                                </div>
                            </a>
                        </div>
                    </div>
                )}

                {/* --- MAIN BUTTON: Toggles the menu --- */}
                <button 
                    onClick={() => setIsOpen(!isOpen)}
                    className="group relative focus:outline-none"
                >
                    {/* Tooltip (Only shows when menu is closed) */}
                    {!isOpen && (
                        <span className="absolute right-full mr-4 top-1/2 -translate-y-1/2 px-3 py-1.5 bg-slate-800 text-white text-xs font-bold rounded-md whitespace-nowrap opacity-0 scale-95 group-hover:opacity-100 group-hover:scale-100 transition-all duration-200 pointer-events-none">
                            Chat on WhatsApp
                        </span>
                    )}

                    <div className={`relative w-16 h-16 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 ${isOpen ? 'bg-slate-800 rotate-45' : 'bg-emerald-500 hover:bg-emerald-600'}`}>
                        {/* Ping Animation (Only when closed) */}
                        {!isOpen && <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>}
                        
                        {/* Icon: Changes from WhatsApp to Close 'X' based on state */}
                        {isOpen ? (
                            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path></svg>
                        ) : (
                            <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                        </svg>
                    )}
                </div>
            </button>
        </div>
    </footer>
    );
};

export default Footer;